import { SanityButtonSection } from 'graphql-types';
import React, { useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import Swiper from 'swiper';
import { usePageContext } from '../context/pageContext';
import { Carousel } from '../ui/carousel/Carousel';
import * as styles from './buttonSection.module.scss';
import { Button } from '../html-tag/Button';
import { Blocks } from '../ui/blocks/Blocks';
import { GatsbyImage } from 'gatsby-plugin-image';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityButtonSection;
}

export const ButtonSection: React.FC<Props> = ({ section }) => {
  const [swiper, setSwiper] = useState<Swiper>();
  const [active, setActive] = useState<number>(0);
  const { lang, defaultLang } = usePageContext();

  return (
    <div
      className={`${styles.wrapper} ${
        section?.backgroundColor === 'grey' && styles.wrapperBgGrey
      } ${section?.backgroundColor === 'white' && styles.wrapperBgWhite} ${
        section?.backgroundColor === 'black' && styles.wrapperBgBlack
      }`}
    >
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      <div className={styles.over}>
        <div className={styles.buttons}>
          <div className={styles.mobile}>
            <Carousel
              setSwiper={setSwiper}
              slidesPerView={'auto'}
              spaceBetween={10}
            >
              {section?.buttonsList?.map((button, index) => {
                return (
                  <SwiperSlide
                    key={`button-${button?._key}`}
                    style={{ width: 'fit-content' }}
                  >
                    <Button
                      label={findTranslation(button?._rawLabel, lang, defaultLang)}
                      onClick={() => setActive(index === active ? -1 : index)}
                      dataType={active === index ? section?.colorNav : `${section?.colorNav}white`}
                    />
                  </SwiperSlide>
                );
              })}
            </Carousel>
          </div>

          <div className={styles.desktop}>
            {section?.buttonsList?.map((button, index) => {
              return (
                <Button
                  label={findTranslation(button?._rawLabel, lang, defaultLang)}
                  onClick={() => setActive(index === active ? -1 : index)}
                  dataType={active === index ? section?.colorNav : `${section?.colorNav}white`}
                  key={`button-${index}`}
                />
              );
            })}
          </div>

          <div className={styles.contentList}>
            {section?.buttonsList?.map((button, index) => {
              return (
                <React.Fragment key={`list-${button?._key}`}>
                  {active === index && (
                    <>
                      {button?.contentList?.map((content) => {
                        return (
                          <div
                            className={styles.row}
                            key={`content-${content?._key}`}
                          >
                            <div className={styles.content}>
                              <Blocks
                                blocks={findTranslation(content?._rawContent, lang, defaultLang)}
                              />
                            </div>
                            <div className={styles.image}>
                              <GatsbyImage
                                alt={content?.img?.alt ?? ''}
                                image={content?.img?.img?.asset?.gatsbyImageData}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
